var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnglish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3802_861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65355 3.62939C1.02514 4.44699 0.551297 5.38933 0.275391 6.41305H4.4372L1.65355 3.62939Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7242 6.41302C15.4483 5.38933 14.9745 4.44699 14.3461 3.62939L11.5625 6.41302H15.7242Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.275391 10.5872C0.551328 11.6108 1.02517 12.5532 1.65355 13.3708L4.43711 10.5872H0.275391Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8705 2.15382C12.0529 1.52542 11.1106 1.05157 10.0869 0.775635V4.93742L12.8705 2.15382Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12939 14.8463C3.94699 15.4747 4.88933 15.9486 5.91302 16.2245V12.0627L3.12939 14.8463Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91299 0.775635C4.8893 1.05157 3.94696 1.52542 3.12939 2.15379L5.91299 4.93738V0.775635Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0869 16.2245C11.1106 15.9486 12.0529 15.4747 12.8705 14.8463L10.0869 12.0627V16.2245Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 10.5872L14.3461 13.3708C14.9745 12.5532 15.4483 11.6108 15.7242 10.5872H11.5625Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9323 7.45653H9.04353H9.0435V0.567719C8.70191 0.52325 8.35366 0.5 8 0.5C7.64628 0.5 7.29809 0.52325 6.95653 0.567719V7.45647V7.4565H0.0677188C0.02325 7.79809 0 8.14634 0 8.5C0 8.85372 0.02325 9.20191 0.0677188 9.54347H6.95647H6.9565V16.4323C7.29809 16.4768 7.64628 16.5 8 16.5C8.35366 16.5 8.70191 16.4768 9.04347 16.4323V9.54353V9.5435H15.9323C15.9768 9.20191 16 8.85372 16 8.5C16 8.14634 15.9768 7.79809 15.9323 7.45653Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0869 10.5869L13.6568 14.1568C13.821 13.9927 13.9776 13.8211 14.127 13.6432L11.0707 10.5869H10.0869V10.5869Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91317 10.5869H5.91311L2.34326 14.1568C2.50739 14.3209 2.67898 14.4776 2.85686 14.627L5.91317 11.5706V10.5869Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91317 6.41299V6.41292L2.3433 2.84302C2.17911 3.00714 2.02248 3.17874 1.87305 3.35661L4.92939 6.41296H5.91317V6.41299Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0869 6.4132L13.6568 2.84327C13.4927 2.67908 13.3211 2.52245 13.1432 2.37305L10.0869 5.42939V6.4132Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3802_861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/english.7050131ce36427000330820a0a4fdd56.svg";
export { ForwardRef as ReactComponent };